import { useStore } from "@tanstack/react-form";

import { withForm } from "~/components/form/app-form";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "~/components/ui/card";
import { COACH_CURRENCIES } from "~/lib/shared/constants/currencies";
import { amountInputStep } from "~/lib/shared/currency";

import { offerFormOptions } from "../offer-form-options";

const CURRENCY_OPTIONS = COACH_CURRENCIES.map((c) => ({ value: c, label: c }));

export const PricingSection = withForm({
  ...offerFormOptions,
  render: function Render({ form }) {
    const directSale = useStore(form.store, (s) => s.values.directSaleEnabled);
    const currency = useStore(form.store, (s) => s.values.currency);
    const step = amountInputStep(currency ?? "USD");

    return (
      <Card>
        <CardHeader>
          <CardTitle>Pricing</CardTitle>
          <CardDescription>
            Set up pricing if you want to sell this directly instead of through
            a discovery call.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <form.AppField name="directSaleEnabled">
            {(field) => <field.CheckboxField label="Enable direct purchase" />}
          </form.AppField>

          {directSale && (
            <div className="space-y-4">
              <div className="grid grid-cols-2 gap-4">
                <form.AppField name="price">
                  {(field) => (
                    <field.NumberField
                      label="Price"
                      placeholder="Enter price"
                      min={0}
                      step={step}
                    />
                  )}
                </form.AppField>

                <form.AppField name="currency">
                  {(field) => (
                    <field.SelectField
                      label="Currency"
                      options={CURRENCY_OPTIONS}
                    />
                  )}
                </form.AppField>
              </div>

              <form.AppField name="originalPrice">
                {(field) => (
                  <field.NumberField
                    label="Original Price (optional, for showing discount)"
                    placeholder="Enter original price"
                    min={0}
                    step={step}
                  />
                )}
              </form.AppField>
            </div>
          )}
        </CardContent>
      </Card>
    );
  },
});
